var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoneLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.978%",
    y1: "2.779%",
    x2: "51.785%",
    y2: "105.142%",
    id: "linearGradient-b8460812-4484-444e-b6af-f9a6704d192c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19DD0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 0a4.97 4.97 0 0 0-3.536 1.464A4.973 4.973 0 0 0 0 5a1 1 0 1 0 2 0c0-.801.312-1.555.879-2.122A2.98 2.98 0 0 1 5 2a1 1 0 1 0 0-2m0 26c-.79 0-1.562-.32-2.121-.879A3.018 3.018 0 0 1 2 23a1 1 0 1 0-2 0c0 1.335.52 2.591 1.465 3.535A4.968 4.968 0 0 0 5 28a1 1 0 1 0 0-2M23 2a2.98 2.98 0 0 1 2.121.878C25.688 3.445 26 4.199 26 5a1 1 0 1 0 2 0c0-1.335-.52-2.591-1.465-3.536A4.966 4.966 0 0 0 23 0a1 1 0 1 0 0 2m4 8a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1M1 18a1 1 0 0 0 1-1v-6a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1M17 0h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2m0 26h-6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2m8.655-.868a.998.998 0 0 0-.525.525l-1.14 2.66-2.596-6.921 6.923 2.595-2.662 1.14Zm5.696-2.14L20.036 18.75a1 1 0 0 0-1.288 1.288l4.243 11.314a1 1 0 0 0 .914.648h.022a1 1 0 0 0 .92-.606l1.964-4.581 4.583-1.965a1 1 0 0 0-.043-1.856Z",
    id: "path-b8460812-4484-444e-b6af-f9a6704d192c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-zoneLarge"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-b8460812-4484-444e-b6af-f9a6704d192c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-b8460812-4484-444e-b6af-f9a6704d192c"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "#868B92",
    xlinkHref: "#path-b8460812-4484-444e-b6af-f9a6704d192c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon-color",
    fill: "url(#linearGradient-b8460812-4484-444e-b6af-f9a6704d192c)",
    mask: "url(#mask-b8460812-4484-444e-b6af-f9a6704d192c)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneLarge);
export default __webpack_public_path__ + "static/media/zoneLarge.4cace433ca98550095eeab08d45b8e7a.svg";
export { ForwardRef as ReactComponent };